<template>
  <div>
    <div class="my-course-bundle">
      <div class="item">
        <h3 v-text="balance.parent_day"></h3>
        <p>
          亲子一日活动

        </p>
      </div>
      <div class="item">
        <h3 v-text="balance.parent_half"></h3>
        <p>
          亲子半日活动

        </p>
      </div>
      <div class="item">
        <h3 v-text="balance.child_day"></h3>
        <p>
          幼儿单飞一日活动
        </p>
      </div>
      <div class="item">
        <h3 v-text="balance.child_half"></h3>
        <p>
          幼儿单飞半日活动
        </p>
      </div>
    </div>

    <div class="button">
      <md-button type="primary" @click="buy()">购买课包</md-button>
      <br>
      <md-button type="default" @click="goLogPage()">课包明细</md-button>
    </div>

    <buy-course-bundle
            :type="type"
            :title="title"
            @close="showBundles = false"
            @onPaymentSuccess="loadAccount()"
            v-if="showBundles"></buy-course-bundle>
  </div>
</template>

<script>
    import {Button,ActionSheet} from 'mand-mobile'
    import BuyCourseBundle from "../components/BuyCourseBundle.vue";


export default {
  name: "my-course-bundle",
  components: {
      [Button.name]: Button,
      BuyCourseBundle,
      [ActionSheet.name]: ActionSheet,
  },
    data() {
        return {
            balance: {parent_day:"-",parent_half:"-",child_day:"-",child_half:"-"},
            showBundles: false,
            type: '',
            title: '',
            options: [
                {label: '亲子一日活动', value: 'parent_day',},
                {label: '亲子半日活动', value: 'parent_half',},
                {label: '幼儿单飞一日活动', value: 'child_day',},
                {label: '幼儿单飞半日活动', value: 'child_half',},
            ],
        }
    },
    created() {
        this.loadAccount();
    },
    methods: {
        buy() {
            ActionSheet.create({
                value: true,
                title: '请选择课包类型',
                options: [
                    {label: '亲子一日活动', value: 'parent_day',},
                    {label: '亲子半日活动', value: 'parent_half',},
                    {label: '幼儿单飞一日活动', value: 'child_day',},
                    {label: '幼儿单飞半日活动', value: 'child_half',},
                ],
                cancelText: '取消',
                onSelected: this.$_selected,
            })
        },
        $_selected(item) {
            console.log(item);
            this.type = item.value;
            this.title = item.label;
            this.showBundles = true;
        },
        loadAccount() {
            this.$http.get('users/account').then(({data}) => this.balance = data);
        },
        goLogPage() {
            this.$router.push('/course-bundle-log')
        }
    },
};
</script>


<style lang="scss" scoped>
.my-course-bundle {
  padding: 80px 20px 20px;
  display: flex;
  flex-flow: wrap;

  .item {
    flex: 0 0 50%;
    text-align: center;
    margin-top: 60px;
    h3 {
      font-weight:normal;
      font-size: 80px;
      margin-bottom: 10px;
    }
    p {
      color: #383838;
      font-size: 28px;
      line-height: 60px;

      svg {
        width: 40px;
        height: 40px;
        vertical-align: text-bottom;
        color: #383838;
      }
    }
  }
}
.button {
  padding: 40px;
  margin-top: 300px;
}
</style>
